import { PricedBond } from "../PricedBond";
import { BondCardCompact } from "../card/BondCardCompact";

export const SimilarBondCard = (props: { pricedBond: PricedBond }) => {
  return <BondCardCompact item={props.pricedBond} />;
};
